import { render, staticRenderFns } from "./serverRecord.vue?vue&type=template&id=e25ee958&scoped=true&"
import script from "./serverRecord.vue?vue&type=script&lang=js&"
export * from "./serverRecord.vue?vue&type=script&lang=js&"
import style0 from "./serverRecord.vue?vue&type=style&index=0&id=e25ee958&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25ee958",
  null
  
)

export default component.exports